<template>
  <v-app id="inspire">
    <v-app-bar app color="indigo" dark extended>
      <v-spacer/>
      <div class="text-center" style="margin-top: 2.6em;">
        <h1 class="header_h1">Digitales W&ouml;rterbuch Deutsch - Windisch</h1>
        <h2 class="header_h2">mit tälerspezifischer Aussprache</h2>
      </div>
      <v-spacer/>
    </v-app-bar>
    <v-main>
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-main>
    <!--    <v-footer color="indigo" app><span class="white&#45;&#45;text">&copy; {{ new Date().getFullYear() }}</span></v-footer>-->
  </v-app>
</template>
<script>
export default {}
</script>
<style scoped>
.header_h1 {
  font-size: 32pt;
}

.header_h2 {
  font-size: 24pt;
}

@media only screen and (max-width: 816px) {
  .header_h1 {
    font-size: 24pt;
    line-height: 140%;
  }

  .header_h2 {
    font-size: 16pt;
    line-height: 140%;
  }
}
</style>
